// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader@4.3.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list-item-group .v-list-item--active{color:inherit}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
